import {
  Button,
} from '@sketchpixy/rubix';
import React from 'react';

import { Meteor } from 'meteor/meteor';

import { Reactive } from '../../common/Reactive.mixin.js';
import { Reservations } from '../../../collections/reservations/reservations';


@Reactive({
	subscriptions: ["reservations"],
})
export class TunelPayementComponent extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			reservation : props.reservation,
      disabled: false
		};

	}

	changeState(event) {

    this.setState({
      disabled: true
    });

		Reservations.update(this.state.reservation._id, {
			"$set": {
				state: event.target.value
			}
		}, (err) => {
			if (err)
				return Messenger().post({
					message: "La modification du statut de la commande a échoué [" + err + "]",
					type: "error"
				});

			Messenger().post({
				message: "Le statut de la commande a été modifié",
				type: "success"
			});
			this.setState({
				reservation: Reservations.findOne(this.state.reservation._id),
        disabled: false
			});
		});
	}

	consume() {
		if(_.includes(Meteor.user().roles, 'god')) {

			 if (confirm("Voulez-vous forcer la consommation de cette réservation ?")) {
			 		let event = {
			 			target: {
			 				value: 6
			 			}
			 		};
          this.state.reservation.consume();
			 		this.changeState(event);
			 };
		}
	}

	unconsume() {
		if(_.includes(Meteor.user().roles, 'god')) {

			 if (confirm("Voulez-vous forcer la de-consommation de cette réservation ?")) {
			 		let event = {
			 			target: {
			 				value: 5
			 			}
			 		};

					Reservations.update(this.state.reservation._id, {"$set": { 'scheduledAt' : null }});
			 		this.changeState(event);
			 };
		}
	}


	render() {
		return (
			<div>
				{this.state.reservation.state < 3 &&
					<Button bsStyle="primary" value="3" ref="btn" onClick={::this.changeState} disabled={this.state.disabled}>Confirmer le paiement</Button>
				}
				{this.state.reservation.state == 3 &&
					<Button bsStyle="primary" value="4" ref="btn" onClick={::this.changeState}>Confirmer la commande</Button>
				}
				{this.state.reservation.state == 4 &&
					<Button bsStyle="primary" value="5" ref="btn" onClick={::this.changeState} >Confirmer l'expédition</Button>
				}
				{this.state.reservation.state == 5 &&
					<Button bsStyle="success" onDoubleClick={::this.consume}>Commande complète</Button>
				}
				{this.state.reservation.state == 6 &&
					<Button onDoubleClick={::this.unconsume}>Commande volée</Button>
				}
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/universal/components/reservations/components/component-tunnel-payement.js
 **/